// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__sMr+q","left":"Virtual_left__yNNvD","wrapper":"Virtual_wrapper__xZkwC"};